module.exports = __webpack_public_path__ + "media/images/cms/img_slide_14-f93190e156e1a12d985ab6811573b41c.jpg";